import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx, _cache) {
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_divider = _resolveComponent("v-divider")
  const _component_TwoFactorForm = _resolveComponent("TwoFactorForm")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_BaseDialog = _resolveComponent("BaseDialog")
  const _component_AuthCard = _resolveComponent("AuthCard")

  return (_openBlock(), _createBlock(_component_AuthCard, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("h1", { class: "text-black" }, "Two Factor Authentication Setup", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_divider)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "8" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("p", null, [
                _createTextVNode(" The BMW International Feedback Management web application requires every user to set up two factor authentication. "),
                _createElementVNode("br"),
                _createElementVNode("b", null, "Use this QR Code"),
                _createTextVNode(" to set up a compatible authentication app of your choice to generate security codes for the login procedure. ")
              ], -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "d-flex justify-end" }, [
                _createElementVNode("img", {
                  id: "qrCode",
                  src: "",
                  class: "qr-code-img"
                })
              ], -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_divider)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "8" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("p", null, " Download an authenticator app from the app store for your device and use it to scan the QR code above. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: _ctx.appStoreLogo,
                  class: "store-logo"
                }, null, 8, _hoisted_2),
                _createElementVNode("img", {
                  src: _ctx.playStoreLogo,
                  class: "store-logo"
                }, null, 8, _hoisted_3)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_divider)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("p", null, " After the app is set up, use it to generate a security code to confirm the activation. ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                _createElementVNode("b", { class: "text-red" }, "Attention"),
                _createTextVNode(" : "),
                _createElementVNode("br"),
                _createTextVNode(" Please make sure that the clock on your mobile device is synchronized with the internet. "),
                _createElementVNode("br"),
                _createTextVNode(" If the server and your device times don't match, the generated codes will be invalid. ")
              ], -1)),
              _createVNode(_component_TwoFactorForm, {
                onSubmit: _ctx.submit,
                loading: _ctx.loading
              }, null, 8, ["onSubmit", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_BaseDialog, {
        label: "Error",
        width: 300,
        modelValue: _ctx.tokenErrorPopupVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.tokenErrorPopupVisible) = $event))
      }, {
        default: _withCtx(() => [
          _cache[9] || (_cache[9] = _createElementVNode("p", null, "Token is invalid.", -1)),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            tile: "",
            onClick: _ctx.goToLoginPage
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Back to login ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_BaseDialog, {
        label: "Success",
        width: 300,
        modelValue: _ctx.successPopupVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.successPopupVisible) = $event))
      }, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("p", null, "Activation successful.", -1)),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            tile: "",
            onClick: _ctx.onSuccess
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode(" Continue ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}